import React from 'react';
import Compliancesection from './NewEPR/Compliancesection';
import Hero from './NewEPR/Hero';
import LastSection from './NewEPR/LastSection';
import Secondcomp from './NewEPR/Secondcomp';

export default function NewEPR() {
 return (
  <>
   <Hero />
   <Secondcomp />
   <Compliancesection />
   <LastSection />
  </>
 );
}
